import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=3cb1cbcf&scoped=true&"
import script from "./RemindPassword.vue?vue&type=script&lang=ts&"
export * from "./RemindPassword.vue?vue&type=script&lang=ts&"
import style0 from "./RemindPassword.vue?vue&type=style&index=0&id=3cb1cbcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1cbcf",
  null
  
)

export default component.exports